import {createSlice} from '@reduxjs/toolkit';
import {httpPost} from '../../../util/Rest';
import {CLIENT_MAINTENANCE} from '../../../constants/MicroServiceConstants';

const initialData = {
  clientnotesData: {},
  clientnotesStatus: null,
  clientisLoading: false,
  clienterrorMsg: null,
  clientsuccessMsg: null,
};

const slice = createSlice({
  name: 'addANote',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.clientisLoading = true;
      state.clienterrorMsg = null;
    },
    postNotesData: (state, action) => {
      state.clientnotesStatus = action.payload.status;
      state.clientisLoading = false;
      state.clienterrorMsg = null;
      state.clientsuccessMsg = action.payload.response;
    },
    fetchError: (state, action) => {
      state.clienterrorMsg = action.payload;
      state.clientisLoading = false;
    },
    fetchSuccess: (state, action) => {
      state.clientsuccessMsg = action.payload;
      state.clientisLoading = false;
    },
    resetStatus: (state) => {
      state.clientnotesStatus = null;
      state.clienterrorMsg = null;
    },
    resetMsg: (state) => {
      state.clientsuccessMsg = null;
      state.clienterrorMsg = null;
      state.clientisLoading = false;
      state.clientnotesStatus = null;
    },
  },
});

export default slice.reducer;

// Actions

const {postNotesData, fetchStart, resetMsg, fetchError, resetStatus} = slice.actions;
export const cilentpostNotesInformation = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${CLIENT_MAINTENANCE}/save/notes`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postNotesData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const resetPostStatus = () => {
  return (dispatch) => {
    dispatch(resetStatus());
  };
};
export const clientNotesresetToast = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
